import React                    from 'react';
import {globales,funciones}     from '../../global';
import AuthService              from '../../AuthService';
import {withStyles}             from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import TextField   from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import Button  from '@material-ui/core/Button';
import AuthService_primero from "../../AuthService_primero";
import Request from "superagent";
import Backdrop  from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent          from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import BarraBotones   from '../../components/Barra_menu';
let Auth = new AuthService();
let tokenInfo = [];

var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);


const styles = theme => ({
    formControlText: {
        width: '100%', 
        marginTop: theme.spacing(0),    
        textAlign: 'left',
        marginRight: theme.spacing(2),
       },
       
    paper: { 
        borderRadius: globales.border_dialog,
        minWidth: !movil ? '480px' : undefined,
        maxWidth: !movil ? '480px' : undefined,
        height: !movil ? '630px' : undefined,
        maxHeight: !movil ? '99%' : undefined
       },
   
    paperTitle: { 
      height: '40px', 
       textAlign: 'center', 
      verticalAlign: 'middle',
      lineHeight: '40px',
      margin: "1px " + globales.tabla.marginright + "px 0px " + globales.tabla.marginleft + "px", 
    },
    backdrop: {
        zIndex: 500000,
        color: '#fff', 
        flexDirection: 'column'
      },

      paperConfirm: { 
        borderRadius: globales.border_dialog,
        minWidth: '320px', 
        maxWidth: '320px', 
      },  
    
    });

   

export default withStyles(styles) (
class App extends React.Component {

tablaRef = React.createRef();

  constructor (props) {
    super(props);
    this.Auth_primero = new AuthService_primero();
    this.state = {
       isLoading: false,
       cargando: false,
       isLoggin : undefined,
       heightTableMain: 0,
       rows: [],
       isTypePass1: true,
       isTypePass2: true,
       isTypePass3: true,
       password0:'',
       password1 :'',
       password2 :'',     
       isUnconscionable:false,
       errorMsg0:'',
       errorMsg1:'',
       errorMsg2:'',

       isInsecure:false,
       isIncorrectPass:false,
       openBackDrop:false,
       openModal:false,
       msgModal:'',
       colorText:'',
       RESULT:0

   };

   this.botones_dialog =[  
    {icono: 'Check', toolt: '', nombre: 'Aceptar' ,onclick: this.handleClose, display:'auto'},
   ];


  };//FIN CONSTRUCTOR


  
componentDidMount() { 

    tokenInfo = Auth.getProfile(); //Token decodificado
   
    let _this = this;

    Auth.loggedIn().then( function(b){   
      
        _this.setState({ isLoggin: b }); //Activa el Render (Ademas obtine la informacion del Token en caso que b = true)
        
        
        
      })

};

handleRevelar = (id)=> 
    {     
        if(id===1)
        {
            this.setState({ isTypePass1: this.state.isTypePass1?false:true });
        }
        if(id===2)
        {
            this.setState({ isTypePass2: this.state.isTypePass2?false:true });
        }
        if(id===3)
        {
            this.setState({ isTypePass3: this.state.isTypePass3?false:true });
        }
   
  }

  manejarPegar = (event)=>
  {
    event.preventDefault();
  }

  handleChangePass0=(event)=>
    {
      
      this.setState({password0:event.target.value,isIncorrectPass:false,errorMsg0:''})
      
    }

  handleChangePass1=(event)=>
  {
    
    this.setState({password1:event.target.value})
    this.validarContraseña(event.target.value)
  }

  handleChangePass2=(event)=>
    {
      
      this.setState({password2:event.target.value})

      if(event.target.value!==this.state.password1)
      {
        this.setState({isUnconscionable:true,errorMsg2:'Las constraseña no coinciden.'})
      }
      else
      {
        this.setState({isUnconscionable:false,errorMsg2:''})
      }

      //this.validarContraseña(event.target.value)
    }

    handleClose = () => { 
        this.setState({ openModal: false },()=>{
           
           if(this.state.RESULT)
            {window.location.reload()}

        });
      }

    handleClick_1 = () => {
        
        this.setState({ openBackDrop: true }, ()=>{ 
  
            new Request
            .post(`${globales.ip}/cambiar_clave/cambiar`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .set('Content-Type', 'application/json')
            .send({ USER: tokenInfo.user, 
                    OLD_PASS: this.state.password0,
                    NEW_PASS: this.state.password1 
                  })
            .retry(0)
            .timeout({ response: 20000, deadline: 30000, }) 
            .end((err, res) => {
              
               if (err) { 
            
                  if (err.toString().substr(0,16) === 'Error: Forbidden')
                  {
                    window.location.reload();
                    return;       
                  }
            
                  this.setState({ openBackDrop: false }, ()=>{ 
                    funciones.showToast('e', 'No hay conexión');
                  });
              
                  return;
               }
                  
               const RESP = JSON.parse(res.text); 
              

               if (RESP[0].RESULT === 1)
                { 
                    this.setState({ openBackDrop: false, openModal:true,msgModal:RESP[0].RESP,colorText:'',RESULT:RESP[0].RESULT}, ()=>{ 
                    Auth.logout(); 
                                                                        
                    }
                       
                    );
                }

                else
                {               
                    this.setState({ openBackDrop: false,openModal:true,msgModal:RESP[0].RESP,colorText:'red',RESULT:RESP[0].RESULT }, ()=>{ 
                     /*  funciones.showToast('w', RESP[0].RESP); */ 
                                      
                    });
                }
                      
               
            }); 
          
          });
                   
      };


  validarContraseña = (password) => {
    
    // Expresiones regulares para validación
    const minLength = /.{8,}/;  // Longitud mínima de 8 caracteres
    const hasUppercase = /[A-Z]/; // Al menos una mayúscula
    const hasLowercase = /[a-z]/; // Al menos una minúscula
    const hasNumber = /[0-9]/;    // Al menos un número
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>+-/\\_¿¡=\'°]/; // Al menos un carácter especial

    if (!minLength.test(password)) {
      this.setState({errorMsg1:'La contraseña debe tener al menos 8 caracteres.',isInsecure:true,password2:''});
    } else if (!hasUppercase.test(password)) {
        this.setState({errorMsg1:'Debe incluir al menos una letra mayúscula.',isInsecure:true,password2:''});
    } else if (!hasLowercase.test(password)) {
        this.setState({errorMsg1:'Debe incluir al menos una letra minúscula.',isInsecure:true,password2:''});
    } else if (!hasNumber.test(password)) {
        this.setState({errorMsg1:'Debe incluir al menos un número.',isInsecure:true,password2:''});
    } else if (!hasSpecialChar.test(password)) {
        this.setState({errorMsg1:'Debe incluir al menos un símbolo.',isInsecure:true,password2:''});
    } else {
        this.setState({errorMsg1:'',isInsecure:false,password2:''});  // Si cumple con todos los requisitos
    }
  };

render() {

  const { classes } = this.props; 

  


  if (this.state.isLoggin === true)
  {
  return (
    
    <React.Fragment>
   
          {
            (() => {
              
              return (
                <React.Fragment>

<div className={classes.paperTitle}>
<Typography component='span' variant="h6" className="disableTouchOptions">
    <strong>Cambio de contraseña</strong>
</Typography>

<Paper variant="outlined" style={{ margin: !movil ? "15px 30%" : "15px 5%", /* textAlign: "center" ,*/ padding: !movil ? 30 : 20 }} className="disableTouchOptions">

{/* <Typography style={{paddingBottom:10 }} dangerouslySetInnerHTML={{ __html: requisitos}} />  */}
<div style={{ display: 'flex', justifyContent: 'center', textAlign: 'justify', width: '100%' }}>
      <Typography variant="body2" >
      <b> Tu nueva contraseña debe cumplir con los siguientes requisitos: </b>
      <br></br>
      <br></br>
      <b>1. Longitud mínima: </b> La contraseña debe tener al menos 8 caracteres.
      <br></br>
      <b> 2. Diversidad de caracteres:</b> Utiliza una combinación de:
      <ul>
<li>Letras mayúsculas y minúsculas.</li>
<li>Números.</li>
<li>Símbolos (<b> @ </b>, <b>#</b>, <b>!</b>, <b>$</b>, <b>%</b>, <b>+</b>, <b>-</b>, <b>*</b>, <b>_</b>, etc. )</li>
</ul>
<br></br>
      </Typography>
    </div>
            <div style={{ display: "flex", flexDirection: "row"}}>
         
            <TextField 
            label="Contraseña actual"   
            variant="outlined"
            value={this.state.password0}
            error={this.state.isIncorrectPass}
            helperText={this.state.errorMsg0}  
            onChange={this.handleChangePass0}                                                                      
            id='ca'
            type={this.state.isTypePass1?'password':'text'}
            className={classes.formControlText}        
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{  maxLength: 50 }}
            /> 

            <div style={{ display: "flex", flexDirection:"row", padding: 7 }}>
                                <Tooltip title={this.state.isTypePass1?"Revelar contraseña":"Ocultar contraseña"} placement="top">
                                <IconButton onClick={ (e) => this.handleRevelar(1)  }>
                                    {this.state.isTypePass1?<VisibilityIcon />:<VisibilityOffIcon/>}   
                                </IconButton>
                                </ Tooltip>                                   
            </ div>

           </ div>


           <div style={{ display: "flex", flexDirection: "row",marginTop:15}}>

            <TextField 
            label="Nueva contraseña"   
            variant="outlined"
            disabled={this.state.password0===""?true:false}
            value={this.state.password1}
            error ={this.state.isInsecure}
            onChange={this.handleChangePass1} 
            helperText={this.state.errorMsg1}                                                                           
            id='cn'
            type={this.state.isTypePass2?'password':'text'}
            className={classes.formControlText}
            onPaste={this.manejarPegar}             
            InputLabelProps={{
            shrink: true,
            }}
            inputProps={{  maxLength: 50 }}
            /> 

            <div style={{ display: "flex", flexDirection:"row", padding: 7 }}>
            <Tooltip title={this.state.isTypePass2?"Revelar contraseña":"Ocultar contraseña"} placement="top">
                <IconButton onClick={ (e) => this.handleRevelar(2)  }>
                {this.state.isTypePass2?<VisibilityIcon />:<VisibilityOffIcon/>}   
                </IconButton>
            </ Tooltip>                                   
            </ div>

            </ div>

            <div style={{ display: "flex", flexDirection: "row",marginTop:15}}>

            <TextField 
            label="Confirmar nueva contraseña"   
            variant="outlined"
            value={this.state.password2}
            error ={this.state.isUnconscionable}
            onChange={this.handleChangePass2} 
            disabled={ this.state.password1===""?true: this.state.isInsecure }
            helperText={this.state.errorMsg2}                                                                            
            id='cnc'
            type={this.state.isTypePass3?'password':'text'}
            className={classes.formControlText}   
            onPaste={this.manejarPegar}     
            InputLabelProps={{
            shrink: true,
            }}
            inputProps={{  maxLength: 50 }}
            /> 

            <div style={{ display: "flex", flexDirection:"row", padding: 7 }}>
            <Tooltip title={this.state.isTypePass3?"Revelar contraseña":"Ocultar contraseña"} placement="top">
                <IconButton onClick={ (e) => this.handleRevelar(3)  }>
                {this.state.isTypePass3?<VisibilityIcon />:<VisibilityOffIcon/>}   
                </IconButton>
            </ Tooltip>                                   
            </ div>

            </ div>

            <Button disabled={  this.state.password2!==''?  this.state.isUnconscionable===false?this.state.password0!==''?false:true:true:true } variant="contained" color="primary" onClick={this.handleClick_1} style={{ textTransform: 'none' }}>
                    Cambiar la contraseña
            </Button>

            

</ Paper>
</div>
<Backdrop className={classes.backdrop} open={this.state.openBackDrop}>                                       
    <CircularProgress color="inherit" />
    <span style={{ marginTop: '10px' }}>{'Por favor espere.'}</span>
    </Backdrop>

    <Dialog open= {this.state.openModal}
                     classes = {{ paper: classes.paperConfirm }}>
                   <DialogTitle><Typography component='span' variant='subtitle2'>Notificación</Typography>
                     
                   </DialogTitle>
                   <DialogContent style={{ paddingTop: "20px", textAlign: "center" }}>
                   
                  {/*  <div   style={{textAlign: 'center', color: this.state.colorText}}  dangerouslySetInnerHTML={{__html:this.state.msgModal}} ></div> */}
                   <Typography style={{textAlign: 'center', color: this.state.colorText}} variant="body2" dangerouslySetInnerHTML={{ __html: this.state.msgModal}} />
                   </DialogContent>                        
                   <DialogActions style={{ marginTop: '5px'}}>
                    <BarraBotones botones={this.botones_dialog} /> 
                   </DialogActions>
    </Dialog>   
                    
                </React.Fragment>
              );

                         
             
            })()

          }

          

        </React.Fragment>
  );
  }
else if (this.state.isLoggin === false)
{
  //Auth.logout();
  window.location.reload();
  return; //((<Redirect to="/login"/>))
}
return null;

}//FIN RENDER
}

)
